<div class="bg-white border rounded p-3 mb-3">
  <div class="d-flex justify-content-between align-items-center mb-2">
    <h6 class="mb-0">
      Selected Persons <span class="fw-normal">({{ persons.length }})</span>
    </h6>
    @if (persons.length > 0) {
      <button type="button" class="btn btn-outline-secondary" (click)="removeAll.emit()">Remove All</button>
    }
  </div>
  @if (persons.length === 0) {
    <p class="mb-0">No persons selected yet.</p>
  } @else {
    <div class="d-flex flex-wrap gap-2">
      @for (p of persons; track p.personId) {
        @if (p.firstName || p.lastName || p.ein) {
          <span class="badge badge-primary-light d-flex align-items-center gap-1 py-2 px-2">
            {{ p.firstName }} {{ p.lastName }} ({{ p.ein }})
            <button
              type="button"
              class="btn-close btn-close-primary ms-1"
              style="font-size: 0.6rem"
              (click)="remove.emit(p.personId)"
            ></button>
          </span>
        }
      }
    </div>
  }
</div>
